import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import axiosInstance, { clearAuthData, isJwtAuthFailure } from "../../components/content/axiosConfig";
import Preloader from "../../components/custom/preLoader";
import showErrorToast, { showSuccessToast } from "../../components/toast/toast";

const UpdateScientist = () => {
  const history = useHistory();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    status: true,
  });

  useEffect(() => {
    const fetchScientist = async () => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.get("/api/User/GetIndependentScientist", {
          params: { id },
        });
        const scientist = response.data;
        setFormData({
          fullName: scientist.FullName || "",
          email: scientist.Email || "",
          status: Boolean(scientist.Status),
        });
      } catch (error) {
        if (isJwtAuthFailure(error)) {
          clearAuthData();
          window.location.href = "/user/login";
          return;
        }
        showErrorToast(error.response?.data?.message || "Failed to load scientist");
        history.push("/scientists");
      } finally {
        setIsLoading(false);
      }
    };

    fetchScientist();
  }, [history, id]);

  const handleChange = (e) => {
    const { id: fieldId, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [fieldId]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      await axiosInstance.post(
        "/api/User/UpdateIndependentScientist",
        {
          FullName: formData.fullName,
          Status: formData.status,
        },
        { params: { id } }
      );
      showSuccessToast("Scientist updated successfully");
      history.push("/scientists");
    } catch (error) {
      if (isJwtAuthFailure(error)) {
        clearAuthData();
        window.location.href = "/user/login";
        return;
      }
      showErrorToast(error.response?.data?.message || "Failed to update scientist");
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return <Preloader />;
  }

  return (
    <div>
      <form onSubmit={handleSubmit} className="fs-13px">
        <div className="d-flex align-items-center mb-3">
          <div>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/scientists">Scientists</Link>
              </li>
              <li className="breadcrumb-item active">Edit</li>
            </ul>
            <h1 className="page-header mb-0">Edit Scientist</h1>
          </div>
        </div>

        <div className="card border-0">
          <div className="card-body">
            <div className="row mb-3">
              <label className="form-label col-form-label col-md-3" htmlFor="fullName">
                Full Name
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control"
                  id="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <label className="form-label col-form-label col-md-3" htmlFor="email">
                Email
              </label>
              <div className="col-md-9">
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  value={formData.email}
                  disabled
                  readOnly
                />
              </div>
            </div>

            <div className="row mb-3">
              <label className="form-label col-form-label col-md-3">Status</label>
              <div className="col-md-9">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="status"
                    checked={formData.status}
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="status">
                    {formData.status ? "Active" : "Inactive"}
                  </label>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-9 offset-md-3">
                <button type="submit" className="btn btn-primary" disabled={isSaving}>
                  {isSaving ? "Saving…" : "Save Changes"}
                </button>
                <Link to="/scientists" className="btn btn-default ms-2">
                  Cancel
                </Link>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UpdateScientist;
